<template>
    <div>
        <el-table :data="dataList" border highlight-current-row style="width: 100%;" :height="formHeight" v-loading="listLoading" 
        :row-class-name="tableRowClassName" @cell-mouse-enter="handleMouseEnter" @cell-mouse-leave="handleMouseLeave" size="small"   ref="table">
            <el-table-column type="index" label="序号"  fixed></el-table-column>
            <!-- <el-table-column prop="Date" label="MN" width="160" fixed></el-table-column> -->
            <el-table-column prop="time" label="监测时间" width="160" fixed sortable>
                <template slot-scope="scope">
                    <span v-if="dataType=='day'" >{{scope.row.time.split(' ')[0]}}</span>
                    <span v-else >{{scope.row.time}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="是否校准" width="160" fixed v-if="dataType=='min'">
                <template slot-scope="scope">
                    <span v-if="scope.row.cal=='1'"  style="color:red;cursor: pointer;" >是</span>
                    <span v-else >否</span>
                </template>
            </el-table-column>
            <el-table-column  label="是否含录音" width="160" fixed v-if="showRecording">
                <template slot-scope="scope">
                    <span v-if="scope.row.noisefile!=undefined&&scope.row.noisefile.length>0"  style="color:red;cursor: pointer;" >
                        <el-button type="text" plain  icon="el-icon-view" v-on:click="queryRecord(scope.$index, scope.row)">查看录音</el-button>
                    </span>
                    <span v-else >否</span>
                </template>
            </el-table-column>
            <el-table-column  label="秒数据" width="160" fixed v-if="dataType=='min'||dataType=='hour'">
                <template slot-scope="scope">
                    <span >
                        <el-button type="text" plain  icon="el-icon-view" v-on:click="querySecondData(scope.$index, scope.row)">查看</el-button>
                    </span>
                </template>
            </el-table-column>
            <el-table-column  label="车流量数据" width="160" v-if="carFlag==1">
                <template slot-scope="scope">
						<table-query-button  @select-type="queryCar(scope.row)"  btnCon="查看详情"></table-query-button>
					</template>
            </el-table-column>
            <el-table-column prop="funName" label="功能区" width="80">
                <template slot-scope="scope">
                    <span >{{funName}}</span>
                </template>
            </el-table-column>
            <el-table-column  v-for="item in facList"    :prop="item.keyWord" :label="item.name" :key="item.keyWord"  min-width="100">
                <el-table-column  prop="name" :label="item.unit"  width="120"> 
                    <template slot-scope="scope">
                        <span v-if="scope.row[item.keyWord]==null" >{{"-"}}</span>
                        <span v-else >
                            <span v-if="item.keyWord=='n00004'&&scope.row.ldFlag==true" class="outLimitWord">
                                {{scope.row[item.keyWord]}}
                            </span>
                            <span v-else-if="item.keyWord=='n00005'&&scope.row.lnFlag==true"  class="outLimitWord">
                                {{scope.row[item.keyWord]}}
                            </span>
                            <span v-else-if="item.keyWord=='n00001'&&scope.row.leqFlag==true"  class="outLimitWord">
                                {{scope.row[item.keyWord]}}
                            </span>
                            <span v-else>
                                {{scope.row[item.keyWord]}}
                            </span>
                        </span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <el-dialog  title="详情" :visible.sync="deviceDataVisible" :close-on-click-modal="true">
            <el-table :data="recordList" border  highlight-current-row v-loading="listLoading"  style="width: 100%;" :max-height="formHeight"   size="small" >
                <el-table-column type="index" label="序号"  ></el-table-column>
                <el-table-column prop="fileTime" label="时间"   sortable  ></el-table-column>
                <el-table-column   label="异常噪声"  >
                    <template slot-scope="scope">
                        <audio :src="scope.row.filePath" controls="controls"></audio>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog  title="详情" :visible.sync="carVisible" :close-on-click-modal="true">
            <h4>车流量（{{carData.time}}）</h4>
            <el-table :data="laneList" border  highlight-current-row v-loading="listLoading"  style="width: 100%;" :max-height="formHeight"   size="small" >
                <el-table-column type="index" label="序号"  ></el-table-column>
                <el-table-column label="车道数" >
                    <template slot-scope="scope">
                       车道{{scope.row.index}}
                    </template>
                </el-table-column>
                <el-table-column prop="vehicleNum" label="车辆总数(辆)"   ></el-table-column>
                <el-table-column prop="svehicleNum" label="小车数量(辆)"   ></el-table-column>
                <el-table-column prop="mvehicleNum" label="中车数量(辆)"   ></el-table-column>
                <el-table-column prop="bvehicleNum" label="大车数量(辆)"   ></el-table-column>
                <el-table-column prop="laneType" label="类别"   >
                    <template slot-scope="scope">
                       <span v-if="scope.row.laneType==0">机动车道</span>
                       <span v-else-if="scope.row.laneType==1">主路</span>
                       <span v-else-if="scope.row.laneType==2">应急车道</span>
                       <span v-else-if="scope.row.laneType==3">非机动车道</span>
                    </template>
                </el-table-column>
                <el-table-column prop="speedAvg" label="平均车速(km/h)"   ></el-table-column>
                <el-table-column prop="occupancyAvg" label="平均占有率(%)"   ></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog  title="秒数据详情" :visible.sync="secondVisible" :close-on-click-modal="true">
            <el-button type="warning" plain  icon="el-icon-download" v-on:click="clickEvent()">导出数据</el-button>
            <div id="secondLine" v-loading="secondLoading"></div>
        </el-dialog>
    </div>
</template>
  
  <script>
  import {in_array,formatDate } from '../../../static/fun.js';
  import TableQueryButton from '../../components/myButton/TableQueryButton.vue'

  import { getCarDataByMN,selectSecondData} from '../../api/api';
  import * as echarts from "echarts";
  
  export default {
    components: { TableQueryButton},
    name: 'auto-data-table',
    props: {
        dataList: {
            type: Array,
            default: () => {
                return []
            }
        },
        facList: {
            type: Array,
            default: () => {
                return []
            }
        },
        formHeight: {
            type: Number,
            default: () => {
                return false
            }
        },
        carFlag: {
            type: Number,
            default: () => {
                return false
            }
        },
        dataType: {
            type: String,
            default: () => {
                return "min"
            }
        },
        collapsed: {
            type: Boolean,
        },
        choosemn: {
            type: String,
        },
        listLoading: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        funName: {
            type: String,
            default: () => {
                return ""
            }
        },
        showRecording: {
            type: Boolean,
            default: () => {
                return true
            }
        }
    },
    data () {
      return {
          indexErr:[],
          recordList:[],
          deviceDataVisible:false,
          carVisible:false,
          secondVisible:false,
          secondLine:null,
          secondLoading:false,
          dataId:0,
          carData:{},
          laneList:[],
          secondList:[]
      }
    },
    mounted () {
        var _this=this;
        window.onresize = function(){
            if(_this.secondLine!=null){
                _this.secondLine.resize();
            }
        }
    },
    watch: {
        dataList(val) {
            this.doLayout();
        },
    },
    methods: {
        handleMouseEnter (row) {
            //非异常
            if(row.exception!=2){
                return;
            }
            //同一行
            if(row.id==this.dataId){
                return;
            }
            this.dataId=row.id;
            var json=JSON.parse(row.content);
            this.popCon =json.preReview.remark;
            this.$notify({
                title: row.time,
                message: this.popCon,
                position: 'bottom-right'
            });
        },
        handleMouseLeave (row) {
            if(row.exception!=2){
                this.dataId=row.id;
                return;
            }
        },
        queryRecord(i,row){
            this.recordList=row.noisefile;

            //处理录音文件位置
            for (let index = 0; index <  this.recordList.length; index++) {
                const element =  this.recordList[index];
                if(element.filePath.indexOf("http://")==-1&&element.filePath.indexOf("https://")==-1){
                    element.filePath=window.configuration.resourceUrlJava+element.filePath;
                }else{
                    //不处理
                }
            }
            this.deviceDataVisible=true;
        },
        querySecondData(i,row){
            var startDate="";
            var endDate="";
            var time1=new Date(row.time);
            
            if(this.dataType=="min"){//前时制
                time1.setSeconds(time1.getSeconds()+1);
                endDate=formatDate(time1);
                time1.setMinutes(time1.getMinutes()-1);
                startDate=formatDate(time1);
            }else if(this.dataType=="hour"){//后时制
                endDate=formatDate(time1);
				time1.setHours(time1.getHours()-1);
                startDate=formatDate(time1);
            }
          
            this.secondVisible=true;
            this.secondLoading=true;

            var para={
                mn:this.choosemn,
                startTime:startDate,
                endTime:endDate
            }
            selectSecondData(para).then((res) => {
                this.secondLoading = false;
                if(res.data.result=="false"||res.data.result==false){
                    this.$message({
                        message: "查询失败，请重试",
                        type: 'error'
                    })
                }else{
                    this.secondList=res.data.datas;
                    this.drawLineChart();
                }
            }).catch(() => {
                this.secondLoading = false;
            });
        },
        drawLineChart:function() {
            document.getElementById("secondLine").style.height=this.formHeight*0.7+"px";
            this.secondLine = echarts.init(document.getElementById('secondLine'));

            this.secondLine.setOption({
                title: {
                    text: '数据趋势图',
                    x:'center'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function(params) {
                        var result = params[0].name+'<br>';
                        params.forEach(function(item) {
                            result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data[item.seriesName]+"</span><br>"
                        });
                        return result;
                    },
                },
                toolbox: {
                    show : true,
                    feature: {
                        dataZoom: {
                            yAxisIndex:"none"
                        },
                        magicType: {show: true, type: ['line', 'bar']},
                        saveAsImage: {
                            show:true,
                            excludeComponents :['toolbox'],
                            pixelRatio: 2
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top:60,
                    containLabel: true
                },
                dataset: {
                    dimensions: ['time', 'leq'],
                    source: this.secondList
                },
                xAxis: [{
                    boundaryGap: true,
                    name:'时间',
                    type: 'category'
                }],
                yAxis: [{
                    type: 'value',
                    name:'数值',
                    scale:true
                }],
                series: [{
                    type: 'line'
                }]
            },true);
        },
        clickEvent(){
            require.ensure([], () => {
                const { export_json_to_excel } = require('vendor/Export2Excel');
                var tHeader =  [ '时间', '数值（dB）' ];
                var filterVal = ['time','leq' ];  

                var data=[];
                var sheetName=[];
                data.push(this.formatJson(filterVal, this.secondList));
                sheetName.push('Sheet1');

                export_json_to_excel(tHeader, data, '秒数据详情',sheetName);
            }) 
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        }, 
        queryCar(row){
            let param={
                mn:this.choosemn,
                type:this.dataType,
                time:row.time
            }
            getCarDataByMN(param).then((res) => {
                this.carData=res.data.datas;
                if(this.carData==null){
                    this.carData={
                        time:row.time
                    }
                    this.$message({
                        message: "暂无数据",
                        type: 'warning'
                    });
                }else{
                    this.carVisible=true;
                    this.carData=res.data.datas;
                    this.laneList=this.carData.laneList;
                }
            });
        },
        tableRowClassName({row, rowIndex}) {
            if ( in_array(rowIndex,this.indexErr)) {
                return 'warn-row';
            } 
            return '';
        },
        doLayout(){
            //先判断异常的行
            this.indexErr=[];
            for (let index = 0; index < this.dataList.length; index++) {
                const element = this.dataList[index];
                if(element.exception==2){
                    this.indexErr.push(index)
                }
            }
            let that = this
            this.$nextTick(() => {
                that.$refs.table.doLayout()
            })
        }
    }
  }
  </script>
  
  <style lang="scss">
   .el-table .warn-row {
    background: #FFCCCC;
  }

  .el-table .outLimitWord{
      color: #daa520;
      font-weight: bold;
  }
  </style>
  


// WEBPACK FOOTER //
// AutoDataTable.vue?67ab51d4